// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__c3pIM","medium":"Container_medium__S_rPq"};